import { render, staticRenderFns } from "./QueryView.vue?vue&type=template&id=33952809&"
import script from "./QueryView.vue?vue&type=script&lang=js&"
export * from "./QueryView.vue?vue&type=script&lang=js&"
import style0 from "./QueryView.vue?vue&type=style&index=0&id=33952809&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports